import http from '@/http'
import { montaUrl } from '@/util/url-util'

export function getAll(filters) {
    let url = montaUrl(filters)
    return http.get(`/api/text/version?${url}`)
}

export function edit(id, data) {
    return http.put(`/api/text/version/${id}`,data)
}